module.exports = __webpack_public_path__ + "img/crown-empty-white.4d590a43.svg";